<template>
  <div class="col-12">
    <Search
      :allowFields="$lang.reportLang.ready_report_fields"
      :hiddenFields="hiddenFields"
      :allowCollapse="false"
      :url="url"
      :title="$lang.reportLang.ready_report_list"
      addModalSize="xl"
      removeModalSize="xl"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :visibleAdd="false"
      :allowEdit="false"
      :dynamicButtons="availableButtons"
      :filterCatch="true"
      :dataNotExist="$lang.notRecordExist"
      ref="readyReport"
      @getPermisson="updatePermissions"
    />
    <b-modal
      no-close-on-backdrop
      v-model="selectTermModal"
      size="md"
      ok-only
      hide-header
      hide-footer
    >
      <b-card>
        <div slot="header">{{ $lang.select_term }}</div>
        <LoadingSpinner :loading="loading" :text="$lang.sending_data" />
        <b-form @submit.prevent="generateReport" v-show="!loading">
          <b-form-group
            :label="$lang.select_term"
            label-for="term_selected"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.select_term"
              :rules="$v.term_selected.$params"
            />

            <selectFind
              :options="term_options"
              v-model="$v.term_selected.$model"
              label="caption"
              id="code"
              :loading="term_loading"
              :isValid="
                $v.term_selected.$dirty ? !$v.term_selected.$error : null
              "
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.term_selected.$error ? 'block' : 'none',
              }"
              id="term_selected_feedback"
            >
              {{ $lang.error_required | replace($lang.select_term) }}
            </b-form-invalid-feedback>
          </b-form-group>
          <div slot="footer" class="form-group form-btn">
            <b-button
              type="submit"
              variant="success"
              v-if="isAdmin(permissions)"
            >
              {{ $lang.submitButton }}
              <i class="fa fa-check" />
            </b-button>
            <b-button
              type="reset"
              class="ml-2"
              variant="danger"
              @click="selectTermModal = false"
            >
              {{ $lang.close }}
              <i class="fa fa-ban" />
            </b-button>
          </div>
        </b-form>
      </b-card>
    </b-modal>
    <Confirm
      v-model="confirmModal"
      title="ساختن خروجی اکسل"
      :description="confirmDescription"
      dynamicClass=""
      :loading="loading"
      :loadingSpinnerText="$lang.updating_data"
      :preventDefault="true"
      @cancel="confirmModal = false"
      @ok="generateReport"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";
import Confirm from "@/components/base/confirm";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { isAdmin, generateApiUrl } from "@/shared/utils";
import { pathOr } from "ramda";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ready-report-search",
  components: {
    Search,
    Confirm,
    LoadingSpinner,
  },
  validations: {
    term_selected: {
      required,
    },
  },
  data() {
    return {
      loading: false,
      hiddenFields: ["created_at.jalali"],
      permissions: [],
      term_options: [],
      term_selected: null,
      term_loading: false,
      selectTermModal: false,
      confirmModal: false,
      currentItem: null,
      availableButtons: [
        {
          id: "0",
          name: "edit",
          iconFont: "fas fa-file-excel fa-lg text-success",
          text: this.$lang.reportLang.generateExcelReport,
          click: this.checkReportAction,
        },
      ],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["report", "ready_report"]);
    },
    confirmDescription() {
      return "<b>آیا برای ساختن خروجی اکسل مطمئن هستید؟</b>";
    },
  },
  watch: {
    selectTermModal(value) {
      value && this.getTerms();
    },
  },
  methods: {
    isAdmin,
    generateApiUrl,
    pathOr,
    updatePermissions(data) {
      this.permissions = data;
    },
    async getTerms() {
      try {
        this.term_loading = true;
        const url = generateApiUrl(["profile", "term_combo"], [], {
          finished: 1,
        });
        const response = await this.$httpService.get(url);
        this.term_options = pathOr([], ["data", "data"], response).map(
          (item) => {
            return {
              caption: `${pathOr("", ["id"], item)} - ${pathOr(
                "",
                ["caption"],
                item
              )}`,
              code: pathOr(null, ["code"], item),
            };
          }
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.term_loading = false;
      }
    },
    checkReportAction(item) {
      this.currentItem = item;
      const filterByTerm = pathOr(false, ["filter_by_term"], item);
      /* guidance: check filter_by_term if is true => show select term form else => show confirm */
      this.selectTermModal = filterByTerm;
      this.confirmModal = !filterByTerm;
    },
    async generateReport() {
      const {
        filter_by_term,
        code: ready_report_code,
        report_caption: name,
        report_name: file_name,
        report_name: mapping_key,
      } = this.currentItem;

      if (!ready_report_code || this.loading) return;

      try {
        this.loading = true;
        const isJobType = pathOr("query", ["type"], this.currentItem) === "job";
        const url = isJobType
          ? generateApiUrl(
              ["report", "ready_report_generate"],
              [ready_report_code]
            )
          : generateApiUrl(["report", "ready_report_export_resource"]);

        let filters = { ready_report_code };

        /* guidance: check filter_by_term if it's true => add term_code key to filter payload */
        const term_code = pathOr(null, ["code"], this.term_selected);
        if (filter_by_term) {
          filters = { ...filters, term_code };
        }

        const payload = {
          name,
          file_name,
          ready_report_code,
          filters,
          mapping_key,
        };
        const jobPayload = filter_by_term ? { term_code } : {};

        const response = isJobType
          ? await this.$httpService.put(url, jobPayload)
          : await this.$httpService.patch(url, payload);

        if (!isJobType) {
          await this.generateReportSecond(ready_report_code);
        }

        this.$notify.success(response.data.message);
        this.selectTermModal = false;
        this.confirmModal = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    async generateReportSecond(code) {
      try {
        const url = generateApiUrl(["report", "ready_report_generate"], [code]);
        await this.$httpService.patch(url);
      } catch (error) {
        this.$generateError(error);
      }
    },
  },
};
</script>
